import { registerEvergreenVideoSource } from '@fhs/home/src/native-homepage-hero/hero-video-preload';

registerEvergreenVideoSource(require('./assets/video/evergreen.mp4'));
